import { CKToastContainer } from '@clearkit/react';
import { Subscribe } from 'unstated';

import ToastsContainer from '~/containers/Toasts';

const ToastNotificationStack = ({ toasts, removeToast }) => (
  <CKToastContainer toasts={toasts} onClose={removeToast} />
);

ToastNotificationStack.propTypes = {
  removeToast: PropTypes.func,
  toasts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      description: PropTypes.string,
      heading: PropTypes.string.isRequired,
      variant: PropTypes.oneOf([
        'default',
        'warning',
        'success',
        'error',
        'special',
        'info',
      ]).isRequired,
    }),
  ),
};

const WrappedToastNotificationStack = (props) => (
  <Subscribe to={[ToastsContainer]}>
    {(toastsContainer) => (
      <ToastNotificationStack
        {...props}
        toasts={toastsContainer.state.toasts}
        removeToast={toastsContainer.removeToast}
      />
    )}
  </Subscribe>
);

export default WrappedToastNotificationStack;
